import { useRequest } from 'ahooks'
import { Spin } from 'antd'
import { createStyles } from 'antd-style'
import { isNil } from 'lodash'

import { queryMemberAccountApi } from '@eastcoal/api/finance/accountOperation/queryMemberAccount'

import { DataError } from '@eastcoal/common/components/DataError'
import { pretty } from '@eastcoal/common/utils/decimal'

import { CheckFreezeAmountListButton } from './components/CheckFreezeAmountListButton'
import { MemberAccountProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  row: {
    display: 'flex',
    flexFlow: 'row nowrap',
    marginBlockEnd: token.marginMD,
    paddingBlock: token.paddingMD,
    backgroundColor: token.colorBgLayout,
    borderRadius: token.borderRadius
  },
  col: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: token.paddingXS,
    textAlign: 'center',
    [`&+&`]: {
      borderLeft: `1px solid ${token.colorFillSecondary}`
    }
  },
  value: {
    fontSize: token.fontSizeHeading4
  },
  label: {
    color: token.colorTextLabel
  }
}))

export const MemberAccount = ({
  className,
  style,
  memberId
}: MemberAccountProps) => {
  const result = useRequest(
    () =>
      queryMemberAccountApi({
        memberId
      }),
    {
      manual: false,
      ready: !isNil(memberId),
      refreshDeps: [memberId]
    }
  )

  const { data = {}, loading, error, refreshAsync } = result

  const items = [
    {
      key: 'balance',
      label: '余额',
      value: pretty(data.balance)
    },
    {
      key: 'activeBalance',
      label: '可用余额',
      value: pretty(data.activeBalance)
    },
    {
      key: 'freezeAmount',
      label: (
        <>
          冻结中金额
          <CheckFreezeAmountListButton memberId={memberId} />
        </>
      ),
      value: pretty(data.freezeAmount)
    }
  ]

  const { cx, styles } = useStyles()

  return (
    <Spin spinning={loading}>
      <DataError error={error} reload={refreshAsync} />
      <div className={cx(styles.row, className)} style={style}>
        {items.map(({ key, label, value }) => (
          <div key={key} className={styles.col}>
            <span className={styles.value}>{value}</span>
            <span className={styles.label}>{label}</span>
          </div>
        ))}
      </div>
    </Spin>
  )
}
